<template>
  <div>
    <revisepayword-mess v-transition></revisepayword-mess>
  </div>
</template>

<script>
import RevisepaywordMess from './components/Mess'
export default {
  name: 'Revisepayword',
  components: {
    RevisepaywordMess
  },
  data () {
    return {
      code: decodeURIComponent(this.$route.query.code)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/revise_pay_password/Revisepayword.vue